import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["newfunktionselect", "form"];
  connect() {
    console.log("did connect BSFunktionenPlanAjaxController.js");
    this.unsavedChanges = false;
  }

  touch(event) {
    event.preventDefault();
    this.unsavedChanges = true;
  }
  untouch() {
    this.unsavedChanges = false;
  }
  async sendnewfunktion(event) {
    console.log("send new funktion " + this.newfunktionselectTarget.value);
    let url = super.ajax_url(
      "createfunktion",
      "BSFunktionenPlanAjaxController",
    );
    let rolleid = this.newfunktionselectTarget.value;
    if (rolleid == 0 || rolleid == "0") {
      alert("Bitte wählen Sie eine Funktion aus!");
      return false;
    }
    let body = JSON.stringify({
      rolle_id: rolleid,
    });
    await this.post(url, body, event);

  }
  async removefunktion(event) {
    if (window.confirm("Soll diese Funktion wirklich gelöscht werden?")) {
      let url = super.ajax_url(
        "remove_funktion",
        "BSFunktionenPlanAjaxController",
      );
      let body = JSON.stringify({
        personen_rolle_id: event.target.dataset.prid,
      });
      await this.post(url, body, event);
    }
  }
  async setbesetzung(event) {
    console.log("send besetzung " + event.target.value);
    let url = super.ajax_url("postbesetzung", "BSFunktionenPlanAjaxController");
    let body = JSON.stringify({
      personen_rolle_id: event.target.dataset.prid,
      besetzungsstand: event.target.value,
    });
    await this.post(url, body, event);
  }
  async setperson(event) {
    console.log("now set person to " + event.target.dataset.rolleId);
    let url = super.ajax_url("postperson", "BSFunktionenPlanAjaxController");
    let body = JSON.stringify({
      personen_rolle_id: event.target.dataset.prid,
      rolle_id: event.target.dataset.rolleId,
      person_id: event.target.value,
    });
    await this.post(url, body, event);
  }
  async setanmerkung(event) {
    console.log("now set anmerkung to " + event.target.dataset.prid + " " + event.target.value);
    let url = super.ajax_url("postanmerkung", "BSFunktionenPlanAjaxController");
    let body = JSON.stringify({
      personen_rolle_id: event.target.dataset.prid,
      anmerkung: event.target.value,
    });
    await this.post(url, body, event);
    this.untouch();
  }
  async setfnr(event) {
    console.log(
      `now set fnr for prid ${event.target.dataset.prid} to ${event.target.value}`,
    );
    let url = super.ajax_url("postfnr", "BSFunktionenPlanAjaxController");
    let body = JSON.stringify({
      personen_rolle_id: event.target.dataset.prid,
      rolle_id: event.target.dataset.rolleId,
      fnr: event.target.value,
      gliederungsnr: event.target.dataset.gliederungsnr
    });
    await this.post(url, body, event);
  }
  async addfach(event) {
    let fach_select = document.getElementById(event.target.dataset.selectId);
    console.log("send fach " + fach_select.value);

    let fach = fach_select.value;
    if (fach == 0 || fach == "0") {
      alert("Bitte wählen Sie ein Fach aus!");
      return false;
    }
    let url = super.ajax_url("add_fach", "BSFunktionenPlanAjaxController");
    let body = JSON.stringify({
      personen_rolle_id: event.target.dataset.prid,
      fach: fach,
    });
    await this.post(url, body, event);
  }
  async removefach(event) {
    console.log("delete fach " + event.target.dataset.fachid);

    let url = super.ajax_url("remove_fach", "BSFunktionenPlanAjaxController");
    let body = JSON.stringify({
      personen_rolle_id: event.target.dataset.prid,
      fachindex: event.target.dataset.fachindex,
    });
    await this.post(url, body, event);
  }
  async reloadContents() {
    let url = super.ajax_url("get_form", "BSFunktionenPlanAjaxController");
    let response = await fetch(url, { method: "GET" });
    const newContent = await response.text();
    this.formTarget.innerHTML = newContent;

  }
  async post(url, body, e) {
    const response = await super.doFetch(url, "POST", body);
    if (response.ok) {
      // window.location.reload();
      this.showmsg("Daten erfolgreich gespeichert");
      this.reloadContents();
    } else {
      e.target.insertAdjacentHTML("afterend", "<span>⚠️</span>");
      alert("Es ist ein Fehler aufgetreten! Status: " + response.status);
      return false;
    }
  }
}
